import React, { useState, useEffect } from "react";
import styles from "./select.module.css";
import { Checkbox } from "@mui/material";
import ElementTitle from "ui/crfs/element_title";
import DividerLine from "ui/crfs/divider_line";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";
import { cloneDeep } from "lodash";
import ElementMenu from "ui/crfs/element_menu";
import { TextField } from "@mui/material";

let tempStorage = null;

export default function Select(props) {
  const {
    field,
    title,
    options,
    onUpdate,
    crf_id,
    crfStatus,
    read_only,
    multi_entry_crf_id,
    captureCompleteDateChangeReason = false,
  } = props;

  const [localValueArray, setLocalValueArray] = useState([]);
  const [showingCompleteChangeModal, setShowingCompleteChangeModal] = useState(false);
  const [localText, setLocalText] = useState(field.value_obj["value2"] || "");

  useEffect(() => {
    if (field.value_obj && field.value_obj.value && field.value_obj.value.constructor === String) {
      try {
        let val = JSON.parse(field.value_obj.value);
        if (val.constructor !== Array) {
          val = [];
        }
        setLocalValueArray(val);
      } catch (err) {
        setLocalValueArray([]);
      }
    } else {
      setLocalValueArray([]);
    }
  }, [field, multi_entry_crf_id, crf_id]);

  const commonUpdateValueActions = (key, action_is_add, reason = null) => {
    let obj = {
      ...field.value_obj,
    };
    obj.value_name = field.value_name;
    let newValue = [...localValueArray];
    if (action_is_add) {
      newValue.push(key);
    } else {
      newValue = newValue.filter((v) => v !== key);
    }
    obj.value = JSON.stringify(newValue);
    obj.currentValueDisplay = options
      .filter((o) => newValue.includes(o.value))
      .map((o) => o.label)
      .join(", ");
    if (reason) {
      obj.reason = reason;
    }
    delete obj.missing;
    onUpdate(obj);
    setLocalValueArray(newValue);
  };

  const updateValue = (key, action_is_add) => {
    if (crfStatus === "data_complete" && captureCompleteDateChangeReason) {
      tempStorage = { key, action_is_add };
      setShowingCompleteChangeModal(true);
      return;
    }
    commonUpdateValueActions(key, action_is_add);
  };

  const acceptTempStorage = (reason) => {
    const { key, action_is_add } = tempStorage;
    commonUpdateValueActions(key, action_is_add, reason);
    tempStorage = null;
    setShowingCompleteChangeModal(false);
  };
  const currentValueDisplay = options
    .filter((o) => localValueArray.includes(o.value))
    .map((o) => o.label)
    .join(", ");

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles["left-split"]}>
          <ElementTitle required={field.required} title={title} />
        </div>
        {read_only || field.read_only ? (
          <div className={styles["right-split"]}>
            <div className={styles.flex}>
              <div>
                {options.map((o) => (
                  <div key={o.value} className={styles.checkbox_row_disabled}>
                    <Checkbox
                      key={o.value}
                      checked={localValueArray.includes(o.value)}
                      className={styles.checkbox}
                      sx={{
                        padding: "0px",
                        marginRight: "6px",
                      }}
                      disabled
                      // onChange={(e) => updateValue(o.value, e.target.checked)}
                    />
                    {o.label}
                  </div>
                ))}
              </div>
              <div className={styles.audit_icon}>
                <ElementMenu {...props} />
              </div>
            </div>
            <div>{field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}</div>
          </div>
        ) : (
          <div className={styles["right-split"]}>
            <div className={styles.flex}>
              <div className={styles.flex_column}>
                {options.map((o) => (
                  <div key={o.value} className={styles.checkbox_row}>
                    <div
                      className={styles.flex}
                      onClick={() => {
                        updateValue(o.value, !localValueArray.includes(o.value));
                      }}
                    >
                      <Checkbox
                        key={o.value}
                        checked={localValueArray.includes(o.value)}
                        className={styles.checkbox}
                        sx={{
                          padding: "0px",
                          marginRight: "6px",
                        }}
                        // onChange={(e) => updateValue(o.value, e.target.checked)}
                      />
                      {o.label}
                    </div>
                    {(localValueArray.includes(o.value) || false) && o.free_text ? (
                      <div>
                        <TextField
                          placeholder=""
                          value={localText}
                          onChange={(e) => setLocalText(e.target.value)}
                          autoComplete="off"
                          sx={{
                            marginLeft: "10px",
                            "& .MuiInputBase-input": {
                              padding: "5px",
                              paddingLeft: "10px",
                              textAlign: "left",
                            },
                          }}
                          fullWidth
                        />
                      </div>
                    ) : null}
                  </div>
                ))}
                {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
              </div>
              <div className={styles.audit_icon}>
                <ElementMenu {...props} />
              </div>
            </div>
          </div>
        )}
      </div>
      <DividerLine />
      <DataCompleteChangeModal
        isOpen={showingCompleteChangeModal}
        close={() => setShowingCompleteChangeModal(false)}
        onYes={acceptTempStorage}
      />
    </div>
  );
}
